<template>
	<span
		:title="label"
		:class="[sizeClass, variantClass]"
		class="inline-flex flex-none items-center justify-center rounded-full font-semibold uppercase tracking-wide select-none">
		{{ initials }}
	</span>
</template>

<script>
export default {
	name: "SupportTicketAvatar",
	props: {
		label: String,
		/**
		 * team: quem responde o chamado | requester: quem abriu o chamado
		 */
		variant: {
			type: String,
			default: "requester"
		},
		size: {
			type: String,
			default: "md"
		}
	},
	computed: {
		/**
		 * Até duas iniciais do nome do autor
		 * @returns {string}
		 */
		initials() {
			const words = (this.label ?? "?").trim().split(/\s+/).filter(Boolean)

			if (!words.length) return "?"

			return words.length === 1
				? words[0].substring(0, 2)
				: `${words[0][0]}${words[words.length - 1][0]}`
		},
		sizeClass() {
			return {
				xs: "h-6 w-6 text-[9px]",
				sm: "h-7 w-7 text-[10px]",
				md: "h-9 w-9 text-xs",
				lg: "h-11 w-11 text-sm"
			}[this.size]
		},
		variantClass() {
			return {
				team: "bg-dark-blue-gray text-white",
				requester: "bg-turquoise/15 text-dark-blue-gray ring-1 ring-inset ring-turquoise/40"
			}[this.variant]
		}
	}
}
</script>
